export const FETCH_NEWSLETTER_REPORT_BY_TAG = 'fetch_newsletter_report_by_tag',
    FETCH_NEWSLETTER_REPORT_BY_TAG_SUCCESS =
        'fetch_newsletter_report_by_tag_success',
    FETCH_NEWSLETTER_REPORT_BY_TAG_ERROR =
        'fetch_newsletter_report_by_tag_error',
    FETCH_NEWSLETTER_REPORT = 'fetch_newsletter_report',
    FETCH_NEWSLETTER_REPORT_SUCCESS = 'fetch_newsletter_report_success',
    FETCH_NEWSLETTER_REPORT_ERROR = 'fetch_newsletter_report_error';
